import React, { useState } from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Chip from "@material-ui/core/Chip";
import NewTag from "./NewTag.js";
import { Grid } from "@material-ui/core";
import update from "immutability-helper";

const useStyles = makeStyles(theme => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
        maxWidth: 300
    },
    chips: {
        display: "flex",
        flexWrap: "wrap"
    },
    chip: {
        margin: 2
    },
    noLabel: {
        marginTop: theme.spacing(3)
    }
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250
        }
    }
};

const getStyles = (name, problem, theme) => ({
    fontWeight: problem.indexOf(name) === -1 ? theme.typography.fontWeightRegular : theme.typography.fontWeightMedium
});

export default props => {
    const classes = useStyles();
    const theme = useTheme();
    const [problem, setProblem] = useState(props.selected);
    const [names, setNames] = useState(props.tags);

    const handleChange = event => {
        setProblem(event.target.value);
        props.onChange(event.target.value);
    };

    return (
        <Grid container spacing={0}>
            <Grid item sm={6} style={{ width: "100%", paddingTop: "14px" }}>
                <InputLabel id="demo-mutiple-chip-label">Vælg Problematikker</InputLabel>
                <Select
                    labelId="demo-mutiple-chip-label"
                    id="demo-mutiple-chip"
                    multiple
                    value={problem}
                    onChange={handleChange}
                    input={<Input id="select-multiple-chip" />}
                    renderValue={selected => (
                        <div className={classes.chips}>
                            {selected.map(value => (
                                <Chip key={value} label={value} className={classes.chip} />
                            ))}
                        </div>
                    )}
                    MenuProps={MenuProps}>
                    {names.map(name => (
                        <MenuItem key={name} value={name} style={getStyles(name, problem, theme)}>
                            {name}
                        </MenuItem>
                    ))}
                </Select>
            </Grid>
            <Grid
                item
                sm={6}
                style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                }}>
                <NewTag
                    onChange={value => {
                        const pr = update(problem, { $push: [value] });
                        setProblem(pr);
                        setNames(update(names, { $push: [value] }));
                        props.onChange(pr);
                    }}
                />
            </Grid>
        </Grid>
    );
};
